import { render, staticRenderFns } from "./BannerShortcutForm.vue?vue&type=template&id=458d9aba&scoped=true&"
import script from "./BannerShortcutForm.vue?vue&type=script&lang=js&"
export * from "./BannerShortcutForm.vue?vue&type=script&lang=js&"
import style0 from "./BannerShortcutForm.vue?vue&type=style&index=0&id=458d9aba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "458d9aba",
  null
  
)

export default component.exports